import { render, staticRenderFns } from "./BagStickyFooter.vue?vue&type=template&id=3c14cbee&scoped=true&"
import script from "./BagStickyFooter.vue?vue&type=script&lang=js&"
export * from "./BagStickyFooter.vue?vue&type=script&lang=js&"
import style0 from "./BagStickyFooter.vue?vue&type=style&index=0&id=3c14cbee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c14cbee",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconCart: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/dynamic/IconCart.vue').default,BagCheckoutButton: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/bag/BagCheckoutButton.vue').default})
